"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomLogin = void 0;
var util_1 = require("../util");
var room_util_1 = require("./room-util");
var room_channel_define_1 = require("./room-channel-define");
var room_error_code_1 = require("./room-error-code");
var collab_room_reporter_1 = __importDefault(require("../report/collab-room-reporter"));
var MAX_LOGIN_ATTEMPT_COUNT = 3; // 登录重试次数限制
var DELAY_LOGIN_TIME = 1500; // 再次登录延迟时间
var shouldRetryLogin = [
    room_error_code_1.RoomWebsocketErrorCode.SOCKET_COLLAB_ROOM_TIMEOUT, room_error_code_1.RoomWebsocketErrorCode.SOCKET_COLLAB_SERVER_TIMEOUT,
    room_error_code_1.RoomWebsocketErrorCode.SOCKET_SERVER_STORAGE_TIMEOUT, room_error_code_1.RoomWebsocketErrorCode.SOCKET_SERVER_CGI_TIMEOUT,
    room_error_code_1.RoomWebsocketErrorCode.SOCKET_FREQUENCY_LIMIT, room_error_code_1.RoomWebsocketErrorCode.SOCKET_GET_PRIVILEGE_TIMEOUT,
];
var shouldReopen = [
    room_error_code_1.RoomWebsocketErrorCode.SOCKET_LAYER_ERROR, room_error_code_1.RoomWebsocketErrorCode.SOCKET_CLIENT_NOT_READY_ERROR,
];
var RoomLogin = /** @class */ (function () {
    function RoomLogin(msgSender, channelOption, roomStatusDependency) {
        this.loginCount = 0;
        this.delayLoginTimer = 0; // 延迟登录定时器
        this.loginSeq = 0;
        this.loginTimeout = 0; // 登录超时定时器
        this.loginTime = 0;
        this.messageSender = msgSender;
        this.channelOption = channelOption;
        this.roomStatusDependency = roomStatusDependency;
    }
    RoomLogin.prototype.dispose = function () {
        this.resetLoginAll();
    };
    RoomLogin.prototype.login = function () {
        if (!this.isConnected()) {
            util_1.ConnectionLog.info('loginRoom: not connected!');
            return;
        }
        this.loginInternal();
    };
    RoomLogin.prototype.resetLoginAll = function () {
        // 不管最后是成功还是失败，只要跳出重试的循环都应该重置所有重试信息，避免下次进循环被影响
        this.resetServerErrorInfo();
        this.resetLogin();
    };
    RoomLogin.prototype.resetServerErrorInfo = function () {
        this.serverErrorInfo = undefined;
    };
    RoomLogin.prototype.resetLogin = function () {
        var _a;
        if (!((_a = this.serverErrorInfo) === null || _a === void 0 ? void 0 : _a.preventResetLoginCount)) {
            // 与上一次 reopen 的错误码相同的情况下，不重置重连次数 避免每次 reopen 都重置重连次数导致无限重连
            this.loginCount = 0;
        }
        this.loginSeq = 0;
        if (this.loginTimeout) {
            clearTimeout(this.loginTimeout);
            this.loginTimeout = 0;
        }
        if (this.delayLoginTimer) {
            clearTimeout(this.delayLoginTimer);
            this.delayLoginTimer = 0;
        }
    };
    RoomLogin.prototype.onLoginResponse = function (head, body) {
        if (head.type === "CLIENT_READY" /* CLIENT_READY */) {
            var result = {
                errCode: room_error_code_1.RoomErrorCode.SUCCESS,
                errMsg: '',
                response: body,
            };
            this.handleLoginResponse(head.task_id, head.type, result);
        }
    };
    RoomLogin.prototype.isConnected = function () {
        return this.messageSender.isConnected();
    };
    RoomLogin.prototype.loginInternal = function () {
        var _this = this;
        var _a, _b, _c, _d;
        if (this.loginTimeout) {
            clearTimeout(this.loginTimeout);
            this.loginTimeout = 0;
        }
        this.loginCount += 1;
        this.loginSeq = util_1.generateMessageTaskId();
        var loginMsgOptions = {
            roomType: 'padpage',
            roomName: "padpage/" + this.channelOption.globalPadId,
            upid: (_a = this.channelOption.upid) !== null && _a !== void 0 ? _a : '',
            gid: this.channelOption.globalPadId,
            sid: this.channelOption.sid,
            tid: this.channelOption.tid,
            sig: this.channelOption.sig,
            data: {
                stats: this.getStats(),
            },
        };
        util_1.ConnectionLog.info("loginRoom: " + "CLIENT_READY" /* CLIENT_READY */ + ", taskId: " + this.loginSeq);
        var loginMsgBody = (_c = (_b = this.channelOption.config) === null || _b === void 0 ? void 0 : _b.customLoginMsgOptions) !== null && _c !== void 0 ? _c : loginMsgOptions;
        this.loginPostData = this.messageSender.createPostData("CLIENT_READY" /* CLIENT_READY */, this.loginSeq, util_1.JsonUtil.jsonStringify(loginMsgBody), (_d = this.channelOption.config) === null || _d === void 0 ? void 0 : _d.loginAdditionalHead);
        this.messageSender.postMessageWithWebsocket(this.loginPostData);
        this.loginTime = room_util_1.RoomUtil.getCurrentTime();
        // 3s超时
        this.loginTimeout = setTimeout(function () {
            util_1.ConnectionLog.warn("loginRoom: time out, seq = " + _this.loginSeq);
            var result = {
                errCode: room_error_code_1.RoomErrorCode.TIMEOUT,
                errMsg: 'login room time out.',
            };
            _this.handleLoginResponse(_this.loginSeq, "CLIENT_READY" /* CLIENT_READY */, result);
        }, 3000);
        // this.messageSender.roomNetworkReporter.reportNetWorkEvent(RoomWebsocketEvent.login, null);
    };
    // eslint-disable-next-line complexity
    RoomLogin.prototype.handleLoginResponse = function (seq, cmd, result) {
        if (this.loginTimeout) {
            clearTimeout(this.loginTimeout);
            this.loginTimeout = 0;
        }
        var reportResult = {
            errCode: 0,
            errMsg: '',
            event: room_channel_define_1.MessageResultEvent.ON_POST,
            needRetry: false,
        };
        if (this.checkLoginResult(result)) {
            // 60009已存在也当成成功
            this.roomStatusDependency.notifyRoomOpened(result);
            reportResult.errCode = result.response.onpost.result;
            this.resetLoginAll();
        }
        else {
            this.handleLoginResponseFail(result, reportResult);
        }
        if (reportResult.errCode !== 0) {
            reportResult.errMsg = room_util_1.RoomUtil.getWebsocketChannelErrorMessage(reportResult.errCode);
            var messageInfo = {
                module: this.channelOption.module,
                cmd: "CLIENT_READY" /* CLIENT_READY */,
                attrName: String(result.errCode || result.response.onpost.result),
                status: 1 /* FAILED */,
                errorMessage: reportResult.errMsg,
            };
            collab_room_reporter_1.default.loginRoomError(messageInfo);
        }
    };
    RoomLogin.prototype.checkLoginResult = function (result) {
        var _a, _b;
        // 60009已存在也当成成功
        return result.errCode === 0 && (((_b = (_a = result.response) === null || _a === void 0 ? void 0 : _a.onpost) === null || _b === void 0 ? void 0 : _b.result) === 0
            || result.response.onpost.result === room_error_code_1.RoomWebsocketErrorCode.SOCKET_COLLAB_ROOM_ALREADY_EXIST);
    };
    RoomLogin.prototype.handleLoginResponseFail = function (result, reportResult) {
        if (result.errCode !== 0) {
            util_1.ConnectionLog.info("handleLoginFailed: client error, code = " + result.errCode + ".");
            if (this.loginCount >= MAX_LOGIN_ATTEMPT_COUNT) {
                // 超过登录次数限制
                util_1.ConnectionLog.info("handleLoginFailed: login count = " + this.loginCount + ".");
                this.resetLogin();
                this.messageSender.closeAndDelayReopen({
                    reason: room_util_1.RoomUtil.getWebsocketChannelErrorMessage(result.errCode),
                    shutDown: false,
                }, 0);
                reportResult.needRetry = false;
            }
            else {
                this.delayLogin(DELAY_LOGIN_TIME);
                reportResult.needRetry = true;
            }
            reportResult.errCode = result.errCode;
            reportResult.event = room_channel_define_1.MessageResultEvent.NET_STATUS_CHANGE;
        }
        else {
            this.handleLoginResponseServerFail(result, reportResult);
        }
    };
    RoomLogin.prototype.handleLoginResponseServerFail = function (result, reportResult) {
        // 处理onpost回包错误
        var serverErrCode = result.response.onpost.result;
        reportResult.errCode = serverErrCode;
        var reason = {
            errCode: serverErrCode,
            reason: room_util_1.RoomUtil.getWebsocketChannelErrorMessage(serverErrCode, 'login failed.'),
            shutDown: false,
        };
        util_1.ConnectionLog.info("handleLoginResponseSvrFail: errCode = " + serverErrCode);
        this.updateServerErrorInfo(serverErrCode);
        if (this.loginCount < MAX_LOGIN_ATTEMPT_COUNT) {
            if (shouldRetryLogin.includes(serverErrCode)) {
                return this.handleLoginRetry(result, reportResult);
            }
            if (shouldReopen.includes(serverErrCode)) {
                return this.messageSender.closeAndDelayReopen(reason, 0);
            }
        }
        this.shutdownByServerFailure(reason, reportResult);
    };
    RoomLogin.prototype.shutdownByServerFailure = function (reason, reportResult) {
        this.resetLoginAll();
        reason.shutDown = true;
        this.messageSender.shutDown(reason);
        reportResult.needRetry = false;
    };
    RoomLogin.prototype.handleLoginRetry = function (result, reportResult) {
        var _a, _b, _c;
        var serverErrCode = result.response.onpost.result;
        var reason = {
            errCode: serverErrCode,
            reason: room_util_1.RoomUtil.getWebsocketChannelErrorMessage(serverErrCode, 'login failed.'),
            shutDown: false,
        };
        if (this.loginCount >= MAX_LOGIN_ATTEMPT_COUNT) {
            this.resetLogin();
            if (serverErrCode === room_error_code_1.RoomWebsocketErrorCode.SOCKET_AUTH_TIMEOUT) {
                this.messageSender.closeAndDelayReopen(reason, 0);
            }
            reportResult.needRetry = false;
        }
        else {
            var retryTime = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.response) === null || _a === void 0 ? void 0 : _a.onpost) === null || _b === void 0 ? void 0 : _b.retry_interval) !== null && _c !== void 0 ? _c : this.delayLoginTime;
            this.delayLogin(retryTime);
            reportResult.needRetry = true;
        }
    };
    RoomLogin.prototype.updateServerErrorInfo = function (serverErrCode) {
        var _a;
        if (((_a = this.serverErrorInfo) === null || _a === void 0 ? void 0 : _a.preErrorCode) === serverErrCode) {
            // 与上一次重试的错误码相同，阻止 retryCount 清零避免 reopen 时丢失重试次数
            this.serverErrorInfo.preventResetLoginCount = true;
        }
        else {
            // 错误码变化重置所有重试信息
            this.serverErrorInfo = {
                preErrorCode: serverErrCode,
                preventResetLoginCount: false,
            };
            this.loginCount = 0;
        }
    };
    RoomLogin.prototype.delayLogin = function (timeout) {
        var _this = this;
        this.delayLoginTimer = setTimeout(function () {
            _this.login();
        }, timeout);
    };
    // clientready使用
    RoomLogin.prototype.getStats = function () {
        var stats = {
            screen: '',
        };
        return stats;
    };
    return RoomLogin;
}());
exports.RoomLogin = RoomLogin;
